(function () {
  var drawer = document.querySelector(".cart-drawer");
  if (!drawer) return;
  var localizePath = window.localizeStorefrontPath || function (path) { return path; };

  var overlay = drawer.querySelector("[data-cart-close]");
  var panel = drawer.querySelector(".cart-drawer__panel");
  var itemsEl = drawer.querySelector("[data-cart-items]");
  var subtotalEl = drawer.querySelector("[data-cart-subtotal]");
  var binIconUrl = drawer.getAttribute("data-bin-icon") || "";

  function openDrawer() {
    drawer.classList.add("is-open");
    drawer.setAttribute("aria-hidden", "false");
  }

  function closeDrawer() {
    drawer.classList.remove("is-open");
    drawer.setAttribute("aria-hidden", "true");
  }

  function formatMoney(cents) {
    if (
      window.MarmorisStorefrontCurrency &&
      typeof window.MarmorisStorefrontCurrency.formatMoneySync === "function"
    ) {
      return window.MarmorisStorefrontCurrency.formatMoneySync(cents);
    }

    if (window.Shopify && typeof window.Shopify.formatMoney === "function") {
      var withCurrencyFormat =
        window.Shopify.money_with_currency_format || window.Shopify.money_format;
      return window.Shopify.formatMoney(cents, withCurrencyFormat);
    }
    var value = (cents / 100).toFixed(2);
    return value;
  }

  function getCartItemImageUrl(imageUrl) {
    if (!imageUrl) return "";

    // Shopify CDN supports width transforms through query params.
    try {
      var url = new URL(imageUrl, window.location.origin);
      url.searchParams.set("width", "240");
      return url.toString();
    } catch (e) {
      return imageUrl;
    }
  }

  function escapeHtml(value) {
    return String(value || "")
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#39;");
  }

  function getCartItemUrl(item) {
    if (!item || !item.url) return "";
    return localizePath(item.url);
  }

  function updateDisplaySubtotal(cart) {
    if (!subtotalEl) return;
    if (!cart || !cart.items || !cart.items.length) {
      subtotalEl.textContent = formatMoney(0);
      return;
    }

    var centsList = cart.items.map(function (item) {
      return item.final_line_price;
    });

    if (
      window.MarmorisStorefrontCurrency &&
      typeof window.MarmorisStorefrontCurrency.sumDisplayedAmounts === "function" &&
      typeof window.MarmorisStorefrontCurrency.formatDisplayAmount === "function"
    ) {
      return window.MarmorisStorefrontCurrency.sumDisplayedAmounts(centsList).then(function (displayAmount) {
        subtotalEl.textContent =
          window.MarmorisStorefrontCurrency.formatDisplayAmount(displayAmount);
      });
    }

    subtotalEl.textContent = formatMoney(
      centsList.reduce(function (sum, cents) {
        return sum + Number(cents || 0);
      }, 0)
    );

    return Promise.resolve();
  }

  function renderCart(cart) {
    if (!itemsEl) return;
    itemsEl.innerHTML = "";

    if (!cart || !cart.items || cart.items.length === 0) {
      itemsEl.innerHTML =
        '<div class="cart-drawer__empty">' +
        "<h2>Your cart is empty.</h2>" +
        '<a class="cart-continue" href="' +
        localizePath("/collections/all") +
        '">Continue Shopping</a>' +
        "</div>";
      updateDisplaySubtotal(cart);
      updateCartIcon(false);
      return;
    }

    cart.items.forEach(function (item) {
      var itemEl = document.createElement("div");
      var itemImageUrl = getCartItemImageUrl(item.image);
      var itemUrl = getCartItemUrl(item);
      var itemTitle = escapeHtml(item.product_title || "");
      var itemVariantTitle =
        item.variant_title && item.variant_title !== "Default Title"
          ? escapeHtml(item.variant_title)
          : "";
      itemEl.className = "cart-drawer__item";
      itemEl.innerHTML =
        '<div class="cart-drawer__item-media">' +
        (itemImageUrl
          ? itemUrl
            ? '<a href="' +
              itemUrl +
              '" class="cart-drawer__item-link" aria-label="' +
              itemTitle +
              '">' +
              '<img src="' +
              itemImageUrl +
              '" alt="' +
              itemTitle +
              '">' +
              "</a>"
            : '<img src="' +
              itemImageUrl +
              '" alt="' +
              itemTitle +
              '">'
          : "") +
        "</div>" +
        '<div class="cart-drawer__item-body">' +
        '<div class="cart-drawer__item-title">' +
        (itemUrl
          ? '<a href="' +
            itemUrl +
            '" class="cart-drawer__item-link">' +
            itemTitle +
            "</a>"
          : itemTitle) +
        "</div>" +
        (itemVariantTitle
          ? '<div class="cart-drawer__item-variant">' +
            itemVariantTitle +
            "</div>"
          : "") +
        '<div class="cart-drawer__item-controls">' +
        '<div class="cart-drawer__qty-wrap">' +
        '<button type="button" class="cart-drawer__qty" data-line="' +
        item.key +
        '" data-qty="' +
        (item.quantity - 1) +
        '">-</button>' +
        '<span class="cart-drawer__qty-value">' +
        item.quantity +
        "</span>" +
        '<button type="button" class="cart-drawer__qty" data-line="' +
        item.key +
        '" data-qty="' +
        (item.quantity + 1) +
        '">+</button>' +
        "</div>" +
        '<button type="button" class="cart-drawer__remove" data-line="' +
        item.key +
        '">' +
        (binIconUrl
          ? '<img src="' + binIconUrl + '" alt="Remove">'
          : "×") +
        "</button>" +
        "</div>" +
        "</div>" +
        '<div class="cart-drawer__item-price" data-money-cents="' +
        item.final_line_price +
        '">' +
        formatMoney(item.final_line_price) +
        "</div>";

      itemsEl.appendChild(itemEl);
    });

    if (
      window.MarmorisStorefrontCurrency &&
      typeof window.MarmorisStorefrontCurrency.enhancePrices === "function"
    ) {
      window.MarmorisStorefrontCurrency.enhancePrices(drawer);
    }

    updateDisplaySubtotal(cart);

    updateCartIcon(cart.item_count > 0);
  }

  function updateCartIcon(hasItems) {
    var icon = document.querySelector(".cart-icon");
    if (!icon) return;
    var dot = icon.querySelector(".cart-icon__dot");
    if (dot) {
      dot.style.display = hasItems ? "inline" : "none";
    }
  }

  function fetchCart() {
    return fetch(localizePath("/cart.js"), {
      credentials: "same-origin",
      headers: { Accept: "application/json" },
    }).then(function (res) {
      return res.json();
    });
  }

  function addItem(payload) {
    return fetch(localizePath("/cart/add.js"), {
      method: "POST",
      credentials: "same-origin",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify(payload),
    }).then(function () {
      return fetchCart();
    });
  }

  function updateItem(key, quantity) {
    return fetch(localizePath("/cart/change.js"), {
      method: "POST",
      credentials: "same-origin",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify({ id: key, quantity: quantity }),
    }).then(function () {
      return fetchCart();
    });
  }

  if (drawer) {
    drawer.addEventListener("click", function (event) {
      var target = event.target;
      if (!target) return;

      var closeTrigger = target.closest("[data-cart-close]");
      if (closeTrigger) {
        closeDrawer();
        return;
      }

      var qtyButton = target.closest(".cart-drawer__qty");
      if (qtyButton) {
        var key = qtyButton.getAttribute("data-line");
        var qty = parseInt(qtyButton.getAttribute("data-qty"), 10);
        if (key) {
          updateItem(key, Math.max(0, qty)).then(renderCart);
        }
        return;
      }

      var removeButton = target.closest(".cart-drawer__remove");
      if (removeButton) {
        var removeKey = removeButton.getAttribute("data-line");
        if (removeKey) {
          updateItem(removeKey, 0).then(renderCart);
        }
      }
    });
  }

  window.CartDrawer = {
    open: function () {
      fetchCart().then(function (cart) {
        renderCart(cart);
        openDrawer();
      });
    },
    addItem: function (payload) {
      return addItem(payload).then(function (cart) {
        renderCart(cart);
        openDrawer();
        return cart;
      });
    },
    refresh: function () {
      return fetchCart().then(renderCart);
    },
    close: closeDrawer,
  };

  fetchCart().then(function (cart) {
    updateCartIcon(cart.item_count > 0);
  });

  document.addEventListener("click", function (event) {
    var target = event.target;
    if (!target) return;
    var button = target.closest(".cart-icon");
    if (!button) return;
    event.preventDefault();
    window.CartDrawer.open();
  });
})();
